var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentConnectIcons35NotificationsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffffff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AgentConnectIcons") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.77,27.49a.46.46,0,0,1-.23-.06.5.5,0,0,1-.22-.67l.28-.54c.88-1.69,1.17-2.26,1.61-8,.42-5.36,4.07-9.1,8.88-9.1h.61a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-.61c-4.33,0-7.5,3.29-7.88,8.17-.46,5.95-.78,6.56-1.72,8.39l-.28.53A.48.48,0,0,1,7.77,27.49Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.84,27.49a.48.48,0,0,1-.44-.28l-.28-.53c-.94-1.83-1.26-2.44-1.72-8.39-.38-4.88-3.55-8.17-7.88-8.17h-.61a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h.61c4.81,0,8.46,3.74,8.88,9.09.44,5.75.74,6.32,1.61,8l.28.54a.5.5,0,0,1-.22.67A.46.46,0,0,1,28.84,27.49Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.6,27.52a.5.5,0,0,1-.1-1,53.14,53.14,0,0,1,21.61,0,.5.5,0,0,1-.2,1,51.9,51.9,0,0,0-21.21,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.31,9.92a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.51.51,0,0,1,18.31,9.92Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.31,29.39a2.5,2.5,0,0,1-2.5-2.49.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5,1.5,1.5,0,0,0,3,0,.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5A2.5,2.5,0,0,1,18.31,29.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentConnectIcons35NotificationsWhite);
export default __webpack_public_path__ + "static/media/AgentConnectIcons_35_notifications_white.c494048bc3df3a596f8caa54f7db634b.svg";
export { ForwardRef as ReactComponent };